class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    
          document.body.classList.add('overflow-hidden');
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    
          document.body.classList.add('overflow-hidden');
    setTimeout(() => {
      this.classList.add('animate', 'active');

          document.body.classList.add('overflow-hidden');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState, { open = true } = {}) {
    if (parsedState._wrCartRevision && parsedState._wrCartRevision < (this.cartRevision || 0)) return;
    this.cartRevision = parsedState._wrCartRevision || this.cartRevision || 0;
    const parser = new DOMParser();
    const drawerHTML = parsedState.sections?.['cart-drawer'];
    if (!drawerHTML) return;
    const incoming = parser.parseFromString(drawerHTML, 'text/html');
    const incomingDrawer = incoming.querySelector('cart-drawer');
    const incomingContents = incoming.querySelector('#CartDrawer');
    const contents = this.querySelector('#CartDrawer');
    if (!incomingDrawer || !incomingContents || !contents) return;
    const wasOpen = this.classList.contains('active');
    this.classList.toggle('is-empty', incomingDrawer.classList.contains('is-empty'));
    this.productId = parsedState.id;
    const checkout = this.querySelector('#CartDrawer-Checkout');
    contents.innerHTML = incomingContents.innerHTML;
    const nextCheckout = this.querySelector('#CartDrawer-Checkout');
    if (checkout && nextCheckout) {
      checkout.disabled = nextCheckout.disabled;
      nextCheckout.replaceWith(checkout);
    }
    const bubbleHTML = parsedState.sections['cart-icon-bubble'];
    const bubble = document.getElementById('cart-icon-bubble');
    const source = bubbleHTML && parser.parseFromString(bubbleHTML, 'text/html').querySelector('.shopify-section');
    if (bubble && source) bubble.innerHTML = source.innerHTML;
    this.querySelector('#CartDrawer-Overlay')?.addEventListener('click', this.close.bind(this));
    if (open) this.open();
    else if (wasOpen) {
      const target = this.querySelector('.drawer__inner');
      if (target) trapFocus(target, target);
    }
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

